import React from "react";
import { IBasketTempItem } from "../../../../../redux/cart/basketTemp/slice";
import { ITempProfileData } from "../../../../../redux/profile/tempProfiles/slice";
import { IProfile } from "../../hooks/useProfileData";
import { ProfileCard } from "../ProfileCard";
import styles from "./FamilyView.module.scss";

interface FamilyViewProps {
  basketTemp: IBasketTempItem[];
  allProfiles: IProfile[];
  tempProfilesData: { [profileId: string]: ITempProfileData };
  updateProfile: (profileId: string, field: keyof ITempProfileData, value: string) => void;
  validateProfile: (profileData: ITempProfileData, profileType: string) => boolean;
}

export const FamilyView: React.FC<FamilyViewProps> = ({
  basketTemp,
  allProfiles,
  tempProfilesData,
  updateProfile,
  validateProfile,
}) => {
  const familySubscription = basketTemp.find((item) => item.type === "family");
  const familyProfiles = allProfiles.filter(
    (p) => p.subscriptionId === familySubscription?.id
  );
  const totalPrice =
    familySubscription?.price || (23000 + ((familySubscription?.totalPeople || 3) - 3) * 1000);

  return (
    <div className={styles.familyView}>
      {familyProfiles.map((profile, index) => (
        <ProfileCard
          key={profile.id}
          profile={profile}
          index={index}
          subscriptionTitle={profile.subscriptionTitle}
          price={index === 0 ? totalPrice : undefined}
          tempProfilesData={tempProfilesData}
          updateProfile={updateProfile}
          validateProfile={validateProfile}
          showPrice={index === 0}
        />
      ))}
    </div>
  );
};

